<h1>Users</h1>
<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  <a mat-tab-link *ngFor="let tab of tabs" (click)="gotoTab(tab)" [active]="tab.link === activeTab.link">
    {{tab.title}}
  </a>
</nav>
<app-superadmin-users-detail *ngIf="activeTab.id === 'detail'"></app-superadmin-users-detail>
<app-superadmin-users-subscription-dunning *ngIf="activeTab.id === 'subscription-dunning'"></app-superadmin-users-subscription-dunning>
<app-superadmin-users-push *ngIf="activeTab.id === 'push'"></app-superadmin-users-push>
<app-superadmin-users-blacklist *ngIf="activeTab.id === 'blacklist'"></app-superadmin-users-blacklist>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
